// initial state
const state = {
  TYPE_NORMAL: 1,
  TYPE_CENTER_STAGE: 2,
  type: [
    {value: 1, label: '普通项目'},
    {value: 2, label: '中台项目'},
  ],
  projectLevel: [
    {value: 1, label: 'A'},
    {value: 2, label: 'B'},
    {value: 3, label: 'C'},
    {value: 4, label: 'S'},
  ],
  reviewGroup: [
    {value: 1, label: '项目负责人'},
    {value: 2, label: '全职审核团队'},
    {value: 3, label: '实习生组长'},
    {value: 4, label: '无需审单'},
  ],
  distributeType: [
    // 5,6 已经合并至 综合服务-渠道管理
    // 2,3 为历史数据，仅支持查看，修改时不可选择
    // 2021-08-24 [1,4] 取消，仅支持查看，修改时不可选择，同时新增条目，并按照xlsx表格给出的顺序排序
    {value: 13, label: '众包服务-终端观测'},
    {value: 14, label: '众包服务-合规保障'},
    {value: 15, label: '众包服务-消费体验'},
    {value: 16, label: '众包服务-共享理货'},
    {value: 17, label: '众包服务-流动拜访'},
    {value: 18, label: '众包服务-库存盘点'},
    {value: 19, label: '众包服务-商品鉴别'},
    {value: 8, label: '数字服务-复杂标注'},
    {value: 7, label: '数字服务-智能拓店'},
    {value: 20, label: '数字服务-智能识别'},
    {value: 21, label: '数字服务-智能排程'},
    {value: 22, label: '数字服务-数据清洗'},
    {value: 23, label: '数字服务-系统开发'},
    {value: 24, label: '数字服务-RPA'},
    {value: 25, label: '数字服务-爱数智'},
    {value: 9, label: '综合服务-灵活用功'},
    {value: 5, label: '综合服务-渠道管理'},
    {value: 10, label: '综合服务-零工交付'},
    {value: 11, label: '其他服务-非业务用'},
    {value: 12, label: '其他服务-其他业务'},

    // 以下部分为废弃部分，历史数据展示需要用到
    {value: 1, label: '众包服务-众包执行'},
    {value: 2, label: '渠道发放(带审核)'},
    {value: 3, label: '渠道发放(不带审核)'},
    {value: 4, label: '众包服务-数据支持'},
    // {value: 6, label: '线外执行与发放(线上结算）'},
  ],
}

// getters
const getters = {}

// actions
const actions = {
  getCustomerProjectTable ({commit, state}, params) {
    return request.alert('getCustomerProjectTable', params)
  },
}

// mutations
const mutations = {}

export const customerProject = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/customer-project/customer-project.store.js